var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconWorldOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.564 20.623c.543-.88.996-2.034 1.329-3.373h3.402a9.027 9.027 0 01-4.73 3.373zm-9.86-3.373h3.404c.332 1.34.785 2.492 1.328 3.373a9.026 9.026 0 01-4.731-3.373zM9.437 3.377c-.543.88-.996 2.033-1.329 3.373H4.705a9.023 9.023 0 014.73-3.373zm9.86 3.373h-3.403c-.333-1.34-.786-2.492-1.329-3.373a9.023 9.023 0 014.731 3.373zm-2.812 4.5a22.954 22.954 0 00-.284-3h3.971c.428.927.703 1.936.79 3h-4.477zm0 1.5h4.478a8.896 8.896 0 01-.79 3H16.2c.155-.943.252-1.95.284-3zm-13.446 0h4.479c.032 1.05.129 2.057.283 3H3.83a8.881 8.881 0 01-.792-3zm4.479-1.5H3.038a8.877 8.877 0 01.792-3H7.8c-.154.943-.251 1.95-.283 3zm7.165-3c.161.9.267 1.906.302 3H9.016c.035-1.094.14-2.1.302-3h5.364zM12 3c.666 0 1.68 1.355 2.342 3.75H9.658C10.319 4.355 11.334 3 12 3zM9.318 15.75c-.161-.9-.267-1.906-.302-3h5.968a20.91 20.91 0 01-.302 3H9.318zM12 21c-.666 0-1.68-1.355-2.342-3.75h4.684C13.681 19.645 12.666 21 12 21zm0-19.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12 17.799 1.5 12 1.5z",
    fill: "currentColor"
  })));
}

export default SvgIconWorldOutline;